import React from 'react';
import { withDashboard } from '../../hoc';
import ProfileForm from '../../components/profile-form';
import PasswordChangeForm from '../../components/change-password-form';

const ProfilePage = () => {
  return (
    <div className="container">
      <ProfileForm />
      <br />
      <PasswordChangeForm />
    </div>
  );
};

export default withDashboard(ProfilePage);
